// @flow
import React from 'react';
import classNames from 'classnames';
import {withStyles} from '@material-ui/core/styles';
import InputAdornment from '@material-ui/core/InputAdornment';
import InputBase from '@material-ui/core/InputBase';
import FormControl from '@material-ui/core/FormControl';
// import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import styles from './Input.styles.js';
import Icon from 'app/components/Icon';

type Props = {
  clases: any,
  className: any,
  label: String,
  icon: String,
  type: String,
  hints: Array<any>,
  fullWidth: boolean
};

type State = {
  value: any
};

class Input extends React.Component<Props, State> {

  constructor(props) {
    super(props);

    this.state = {
      value: '',
    };
  }

  static defaultProps = {
    fullWidth: false
  };

  handleInput = e => {
    if (this.props.onChange) {
      this.props.onChange(e);
    }
    this.setState({value: e.target.value});
  }

  componentDidUpdate(prevProps) {
    if (prevProps.value !== this.props.value) {
      this.setState({value: this.props.value});
    }
  }

  renderElement = (passedProps) => {
    const {classList, type, text, icon, ...props} = passedProps;
    const startAdornment = (
      <InputAdornment position="start" className={classList.classes.adornedStart}>
        <Icon name={icon} className={classList.classes.icon} />
      </InputAdornment>
    );
    if (!type || type === 'text') {
      return <InputBase
              {...props}
              classes={{
                root: classList.classes.inputRoot,
                input: classNames(classList.classes.input, classList.inputClass)
              }}
              value={this.state.value}
              onChange={this.handleInput}
              startAdornment={startAdornment}
            />;
    } else if (type === 'textarea') {
      return <InputBase
              {...props}
              multiline
              classes={{
                root: classNames(classList.classes.inputRoot, classList.classes.textareaRoot),
                input: classNames(
                  classList.classes.input,
                  classList.classes.textarea,
                  classList.inputClass
                )
              }}
              value={this.state.value}
              onChange={this.handleInput}
              startAdornment={startAdornment}
            />;
    } else if (type === 'button') {
      return (
        <Button
          variant="contained"
          color="primary"
          {...props}
          className={classNames(classList.inputClass)}
          value={this.state.value}
          onChange={this.handleInput}
        >
        {icon && <Icon className={classList.classes.buttonIcon} name={icon} />}
        {text}
        </Button>
      );
    }
  }

  render() {
    const {classes, label, className, ...props} = this.props;
    const rootClass = className && className.root;
    const inputClass = (className && className.input) || className;

    return (
      <FormControl fullWidth={this.props.fullWidth} className={classNames(classes.root, rootClass)}>
        {this.props.label && 
          <label className={classes.label}>
            {label}
          </label>
        }
        {this.renderElement({
          classList: {classes, inputClass},
          ...props
        })}

        {this.props.hints && this.props.hints.map((item, index) => {
          return (
            <div key={index} className={classes.hint}>
              {item}
            </div>
          );
        })}
      </FormControl>
    );
  }
}

const Component = withStyles(styles)(Input);
export {Component as Input};
export default Component;